import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  handleIsClientAuthenticated,
  CLIENT_AUTH_CHANGED_EVENT,
} from "../Share/Func/Storage";

/** Re-reads session/local auth whenever the route or client auth storage changes (storage itself is not reactive). */
export default function useClientAuthSession() {
  const location = useLocation();
  const [, setVersion] = useState(0);
  const bump = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => {
    bump();
  }, [location.pathname, location.search, location.hash, bump]);

  useEffect(() => {
    window.addEventListener(CLIENT_AUTH_CHANGED_EVENT, bump);
    return () => window.removeEventListener(CLIENT_AUTH_CHANGED_EVENT, bump);
  }, [bump]);

  return handleIsClientAuthenticated();
}
